import { Controller, useFormContext } from 'react-hook-form'

import { ExpensableBudgetFragment } from 'generated/resources/graphql'

import BudgetFieldComponent from 'modules/expenses/components/expenses/Form/BudgetField'
import { BudgetOption } from 'modules/finance/hooks/useBudgets'

import { castError } from '../../castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from '../../withCustomizationFields'
import withFieldPermissions, { WithFieldPermissionsProps } from '../../withFieldPermissions'

const FIELD_NAME = 'budgetId'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  expensableBudget?: ExpensableBudgetFragment | null
  budgetOptions: BudgetOption[]
  loading: boolean
}

const BudgetField = ({
  isFieldMandatory,
  expensableBudget,
  budgetOptions,
  loading,
  isFieldReadOnly,
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <BudgetFieldComponent
          selectedBudgetId={field.value}
          expensableBudget={expensableBudget}
          budgetOptions={budgetOptions}
          mandatory={isFieldMandatory}
          loading={loading}
          onSelect={(value) => field.onChange(value)}
          error={castError(errors?.budgetId)}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(BudgetField, FIELD_NAME))
